import type { ServiceCategory } from "@/gql/graphql";
import { useServicesUIStore } from "../store/use-services-ui-store";

export function useServicesDialogs() {
  const {
    categoryDialogOpen,
    serviceDialogOpen,
    archiveDialogOpen,
    editingCategory,
    selectedCategoryForService,
    setCategoryDialogOpen,
    setServiceDialogOpen,
    setArchiveDialogOpen,
    setEditingCategory,
    setSelectedCategoryForService,
  } = useServicesUIStore();

  // Dialog handlers
  const handleCreateCategory = () => {
    setEditingCategory(null);
    setCategoryDialogOpen(true);
  };

  const handleEditCategory = (category: ServiceCategory) => {
    setEditingCategory(category);
    setCategoryDialogOpen(true);
  };

  const handleCreateService = (categoryId?: string) => {
    setSelectedCategoryForService(categoryId ?? null);
    setServiceDialogOpen(true);
  };

  const handleOpenArchiveManager = () => {
    setArchiveDialogOpen(true);
  };

  const handleCloseDialogs = () => {
    setCategoryDialogOpen(false);
    setServiceDialogOpen(false);
    setArchiveDialogOpen(false);
    setEditingCategory(null);
    setSelectedCategoryForService(null);
  };

  return {
    // State
    categoryDialogOpen,
    serviceDialogOpen,
    archiveDialogOpen,
    editingCategory,
    selectedCategoryForService,

    // Actions
    handleCreateCategory,
    handleEditCategory,
    handleCreateService,
    handleOpenArchiveManager,
    handleCloseDialogs,

    // Store actions (for direct use in components)
    setCategoryDialogOpen,
    setServiceDialogOpen,
    setArchiveDialogOpen,
  };
}
